var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.config.name,_vm._b({ref:"form",tag:"component",attrs:{"mode":_vm.mode,"disabled":_vm.config.props.multipleEdited},model:{value:(_vm._value),callback:function ($$v) {_vm._value=$$v},expression:"_value"}},'component',_vm.config.props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }